import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchWarehouses(serviceProviderId) {
    return RequesterV1.get(
      `service_provider/warehouse/movements/${serviceProviderId}/list_warehouses`
    );
  },
}
